import { render, staticRenderFns } from "./SelectWholesaleProducts.vue?vue&type=template&id=4cfeeedc"
import script from "./SelectWholesaleProducts.vue?vue&type=script&lang=js"
export * from "./SelectWholesaleProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports